import { render, staticRenderFns } from "./SGDAuthorizationProtocol.vue?vue&type=template&id=d621e732&scoped=true"
import script from "./SGDAuthorizationProtocol.vue?vue&type=script&lang=js"
export * from "./SGDAuthorizationProtocol.vue?vue&type=script&lang=js"
import style0 from "./SGDAuthorizationProtocol.vue?vue&type=style&index=0&id=d621e732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d621e732",
  null
  
)

export default component.exports